import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GuidelinesReferenceCard = ({ guidelines, onViewGuideline, onBrowseAll }) => {
  return (
    <div className="clinical-card p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="BookOpen" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-semibold text-foreground">iRefer Guidelines</h3>
      </div>
      <p className="text-sm text-muted-foreground mb-4">
        Quick access to evidence-based imaging guidelines for clinical decision support.
      </p>
      <div className="space-y-2">
        {guidelines?.map((guideline) => (
          <div 
            key={guideline?.id}
            className="flex items-center justify-between p-3 bg-muted/50 rounded-lg hover:bg-muted transition-clinical"
          >
            <div className="flex items-center gap-3 flex-1">
              <Icon name="FileText" size={16} color="var(--color-primary)" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">
                  {guideline?.title}
                </p>
                <p className="text-xs text-muted-foreground">
                  {guideline?.category}
                </p>
              </div>
            </div>
            <Button 
              variant="ghost" 
              size="xs"
              iconName="ExternalLink"
              onClick={() => onViewGuideline?.(guideline?.id)}
            >
              View
            </Button>
          </div>
        ))}
      </div>
      <Button 
        variant="outline" 
        fullWidth
        iconName="Library"
        iconPosition="left"
        className="mt-4"
        onClick={() => onBrowseAll?.()}
      >
        Browse All Guidelines
      </Button>
    </div>
  );
};

export default GuidelinesReferenceCard;